import { createSlice } from "@reduxjs/toolkit";
import { clearAuth, getAuth, setAuth } from "../../lib/utils";

// Load initial state from localStorage
const loadInitialState = () => {
  if (typeof window !== 'undefined') {
    const storedAuth = getAuth();
    return storedAuth ? storedAuth : { token: null, user: null };
  }
  return { token: null, user: null };
};

const initialState = loadInitialState();

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const newState = {
        token: action.payload.token,
        user: action.payload.user
      };
      setAuth(newState);
      return newState;
    },
    resetUser: () => {
      clearAuth();
      return { token: null, user: null };
    },
  },
});

// Selectors
export const selectUser = (state) => state.user.user;
export const selectToken = (state) => state.user.token;
export const selectIsAuthenticated = (state) => Boolean(state.user.token);

export const { setUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
